webpackJsonp([1],{

/***/ "+jyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("GH5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a080a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("T3vB");
function injectStyle (ssrContext) {
  __webpack_require__("VYGw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a080a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1uMT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2AE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50f20e1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__("XJgb");
function injectStyle (ssrContext) {
  __webpack_require__("iIN0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50f20e1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Payments")]),_vm._v(" "),_c('p',[_vm._v("We make payouts to a Stripe account.")]),_c('p',[_vm._v("Stripe lets you automatically deposit into a bank account for free.")]),_vm._v(" "),(_vm.currentBusiness.paymentMethod)?_c('div',[_vm._m(0)]):_c('div',[_c('button',{staticClass:"btn-primary",on:{"click":_vm.connect}},[_vm._v("Connect with Stripe")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"line-height":"40px"}},[_c('span',{staticStyle:{"color":"#0b0","font-size":"35px","margin-right":"10px"}},[_vm._v("✓")]),_vm._v("Your Stripe account is connected.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7HVi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B06q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Partnerships'
});

/***/ }),

/***/ "CkhE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payments',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentBusiness'])),

  methods: {
    connect: function connect() {
      // TODO state object
      // in state object, hold uid, business id, csrf
      window.location = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_BexzvCse0DS9y3z5RK0ev6vWPOwNnOKo&scope=read_write';
    }
  }
});

/***/ }),

/***/ "Ctsy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Metrics_vue__ = __webpack_require__("Y+oj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fdf468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Metrics_vue__ = __webpack_require__("WTvR");
function injectStyle (ssrContext) {
  __webpack_require__("JA7r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23fdf468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Metrics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fdf468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Metrics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GH5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spinner',

  props: {},

  data: function data() {
    return {
      email: '',
      password: ''
    };
  }
});

/***/ }),

/***/ "JA7r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b766214_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MjRG");
function injectStyle (ssrContext) {
  __webpack_require__("XbKM")
  __webpack_require__("NhSE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b766214"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b766214_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MjRG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingUser || _vm.isBusinessListLoading)?_c('div',{staticClass:"loading-container"},[_c('Spinner')],1):(_vm.isBusinessListEmpty)?_c('div',{staticClass:"container"},[_vm._m(0)]):_c('div',{staticClass:"container"},[_c('nav',{staticClass:"sidebar"},[_c('div',[_c('Logo')],1),_vm._v(" "),_c('router-link',{staticClass:"sidebar-link",attrs:{"to":'/dashboard'}},[_vm._v("Metrics")]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-link",attrs:{"to":'/dashboard/partnerships'}},[_vm._v("Partnerships")]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-link",attrs:{"to":'/dashboard/payments'}},[_vm._v("Payments")]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-link user-control",attrs:{"to":'/dashboard/settings'}},[_vm._v("\n          "+_vm._s(_vm.user.displayName || _vm.user.email || '')+"\n          "),_c('br'),_vm._v(" "),_c('span',{staticClass:"business-name"},[_vm._v(_vm._s(_vm.currentBusiness.displayName))])])],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","flex":"1"}},[_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"800px","margin":"auto"}},[_c('h1',[_vm._v("Welcome to Referberry.")]),_vm._v(" "),_c('p',[_vm._v("Once a referral relationship is set up, all tracking data will be shown here."),_c('br'),_vm._v(" Questions? Give us a shout at "),_c('a',{attrs:{"href":"mailto:hello@referberry.com"}},[_vm._v("hello@referberry.com")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_polyfill__ = __webpack_require__("Xk2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Metrics__ = __webpack_require__("Ctsy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Partnerships__ = __webpack_require__("tHsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Payments__ = __webpack_require__("m0YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UserSettings__ = __webpack_require__("ozKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












function init() {
  var Firebase = window.firebase;

  window.db = Firebase.firestore();
  window.vuexStore = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */];

  // TODO: sometimes prod
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

  var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{ path: '/login', component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */] }, { path: '/dashboard/',
      component: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],
      children: [{ path: '', component: __WEBPACK_IMPORTED_MODULE_5__components_Metrics__["a" /* default */] }, { path: 'partnerships', component: __WEBPACK_IMPORTED_MODULE_6__components_Partnerships__["a" /* default */] }, { path: 'payments', component: __WEBPACK_IMPORTED_MODULE_7__components_Payments__["a" /* default */] }, { path: 'settings', component: __WEBPACK_IMPORTED_MODULE_8__components_UserSettings__["a" /* default */] }]
    }]
  });

  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
    router: router
  }).$mount('#app');

  // Authentication
  var loginRedirect = window.location.pathname;
  Firebase.auth().onAuthStateChanged(function (user) {
    // user change is expected on every page load
    console.log('user changed');
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('setUser', {
      user: user && {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName
      }
    });

    // go to login screen if logged out, and dashboard if logged in
    if (user === null) {
      router.replace('/login');
    } else if (!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.startsWith(router.currentRoute.fullPath, '/dashboard')) {
      if (__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.startsWith(loginRedirect, '/dashboard')) {
        router.replace(loginRedirect);
        loginRedirect = null;
      } else {
        router.replace('/dashboard');
      }
    }
  }, function (error) {
    console.log(error);
  });
}

window.Raven.context(function () {
  init();
});

/***/ }),

/***/ "NhSE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2wN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T3vB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VYGw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WLhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentBusinessId', 'businessListLength', 'businessList'])),

  methods: {
    setCurrentBusinessId: function setCurrentBusinessId(e) {
      this.$store.dispatch('setCurrentBusinessId', { id: e.target.value });
    },
    logout: function logout() {
      window.firebase.auth().signOut();
      localStorage.clear();
    }
  }
});

/***/ }),

/***/ "WTvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Metrics")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.month))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.currentBusinessViews))]),_vm._v(" visits to your site.")]),_c('p'),_c('p',[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.referredPartnerViews))]),_vm._v(" people clicked through to a partner site.")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.referredPurchases))]),_vm._v(" referred purchases.")]),_vm._v(" "),_c('p',[_vm._v("Total estimated earnings: "),_c('span',{staticClass:"number earnings"},[_vm._v(_vm._s(_vm.estimatedEarnings))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XJgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"logo-icon",attrs:{"width":"150px","height":"150px","viewBox":"0 0 556 375","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Brand-concepts---final-more-intense-red-v5-Copy","transform":"translate(-948.000000, -956.000000)"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(908, 880)"}},[_c('g',{attrs:{"id":"Group-2","transform":"translate(303.957741, 266.840746) rotate(-12.000000) translate(-303.957741, -266.840746) translate(81.457741, 41.840746)"}},[_c('g',{attrs:{"id":"Group-2-Copy-4","transform":"translate(222.578890, 225.247019) rotate(50.000000) translate(-222.578890, -225.247019) translate(53.578890, 77.747019)"}},[_c('g',{attrs:{"id":"Group-Copy-4","transform":"translate(106.231196, 98.616671) scale(-1, 1) rotate(70.000000) translate(-106.231196, -98.616671) translate(32.231196, 16.116671)"}},[_c('g',{attrs:{"id":"Oval-2-Copy-3","transform":"translate(76.261319, 82.332441) rotate(33.000000) translate(-76.261319, -82.332441) "}},[_c('path',{attrs:{"fill":"#EAEEBB","stroke":"#f7f8fb","stroke-width":"15","d":"M77.7637304,163.14924 C65.1293912,163.14924 50.4428118,152.219197 42.0636381,136.575113 C34.8113748,123.034994 31.0602551,103.514005 31.0093699,86.4050311 C30.9796812,76.4228959 31.6417683,50.9206132 32.9968796,9.73611573 C33.072169,7.44792302 34.0673236,5.28685118 35.7570703,3.74210186 C39.2218517,0.574633808 44.5983521,0.815653884 47.7658196,4.28043466 C69.9493414,28.5461999 84.0757619,44.0076924 90.146136,50.6660712 C110.146347,72.6035959 120.703765,93.477381 121.45824,108.566887 C122.770103,134.804137 100.400177,163.14924 77.7637304,163.14924 Z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Group-Copy-3","transform":"translate(0.187780, 65.000000)"}},[_c('g',{attrs:{"id":"Oval-2-Copy-3","transform":"translate(107.167615, 120.405165) scale(1, -1) rotate(-40.000000) translate(-107.167615, -120.405165) "}},[_c('path',{attrs:{"fill":"#EAEEBB","stroke":"#f7f8fb","stroke-width":"15","d":"M131.728863,212.736693 C117.066671,212.736693 99.7499693,199.84926 89.8435813,181.353837 C83.5989087,169.69491 64.3833688,122.811391 31.7360985,39.6809954 C30.9385149,37.6500924 30.9524607,35.3902501 31.7750487,33.3693455 C33.5448614,29.0213331 38.5043385,26.9312893 42.8523481,28.7011009 C103.620342,53.4360447 136.976737,69.5842562 145.565678,79.005162 C169.590013,105.356607 182.227484,130.343005 183.121472,148.222765 C184.669733,179.187979 158.193123,212.736693 131.728863,212.736693 Z"}})])]),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-6","stroke":"#f7f8fb","stroke-width":"13","fill":"#FE9B9B","cx":"206","cy":"165","r":"50"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-5","stroke":"#f7f8fb","stroke-width":"13","fill":"#FE9B9B","cx":"212.102508","cy":"103.37638","r":"40"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-4","stroke":"#f7f8fb","stroke-width":"13","fill":"#FE9B9B","cx":"263.857699","cy":"135.128356","r":"32"}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XbKM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//



var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Metrics',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentBusinessViews', 'referredPartnerViews', 'referredPurchases', 'estimatedEarnings']), {
    month: function month() {
      return months[new Date().getMonth()] + ' ' + (new Date().getYear() + 1900);
    }
  })
});

/***/ }),

/***/ "Z1q8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iIN0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iahz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Types/constants

/* harmony default export */ __webpack_exports__["a"] = ({
  // sentinel for uninitialized user (null user represents being logged out)
  loadingUser: 'loadingUser'
});

/***/ }),

/***/ "m0YS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__ = __webpack_require__("CkhE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e10076fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__ = __webpack_require__("2uye");
function injectStyle (ssrContext) {
  __webpack_require__("Z1q8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e10076fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e10076fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner__ = __webpack_require__("+jyM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Firebase = window.firebase;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',

  props: {},

  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  created: function created() {},


  watch: {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLoadingUser'])),

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__Spinner__["a" /* default */]
  },

  methods: {
    loginFacebook: function loginFacebook() {
      // TODO
      alert('Unimplemented.');
    },
    loginGoogle: function loginGoogle() {
      var provider = new Firebase.auth.GoogleAuthProvider();
      provider.addScope('email');
      console.log('logging in w/ google');
      Firebase.auth().signInWithRedirect(provider).then(function (result) {
        console.log('google logged in');
        console.log(result);
      });
    },
    loginEmail: function loginEmail(event) {
      var _this = this;

      event.preventDefault();
      console.log(this.email, this.password);
      Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function (result) {
        console.log(result);
      }).catch(function (error) {
        if (error.code === 'auth/user-not-found') {
          // create new user
          Firebase.auth().createUserWithEmailAndPassword(_this.email, _this.password).then(function (result) {
            // New user created
          }).catch(function (error) {
            // Error with creating non-existant user
            console.log('new user error', error);
            alert(error.message);
          });
        } else {
          // Different error with logging in, such as wrong password
          alert(error.message);
        }
      });
    }
  }
});

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__ = __webpack_require__("sax8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__("iahz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);







// import queryString from 'query-string'

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */]);

var db = window.firebase.firestore();
var debug = "production" !== 'production';

// const userRef = db.collection('user')
var businessRef = db.collection('business');
var partnershipRef = db.collection('partnership');

var monthStart = new Date();
monthStart.setDate(1);
monthStart.setHours(0, 0, 0, 0);

// hold open query listeners so they can be removed if needed
var queryListeners = {};
window.queryListeners = queryListeners;

function dateToLocalIsoString(date) {
  return date.getFullYear() + '-' + __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.padStart(date.getMonth() + 1, 2, '0') + '-' + __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.padStart(date.getDate(), 2, '0');
}

function formatMoney(cents) {
  var str = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.padStart(cents + '', 3, '0');
  var dollars = str.substr(0, str.length - 2);
  var pennies = str.substr(-2);
  return '$' + dollars + '.' + pennies;
}

/**
 * Attaches Firestore listener to actions, letting us receive data from Firestore
 * - automatically clears any old listener bound to a given action with the same id
 * - idempotent if action, id, query are equal
 * @param {string} action - the action to invoke on the store when a db update is received
 * @param {string} id - identifier for the listener bound to this action. Same ID as previous will cause deregistering and replacement of listener
 * @param {CollectionReference or DocumentReference} query - firestore ref on which to listen. If falsy, then any old listener can still be deregistered, and action is called with clearing data
 * @param {object} clearingData - if provided, action is immediately invoked with clearing data to set loading/empty state and clear old data
 * @param {function} transform - modifies snapshot from db for action
 * @param {string} cachingKey - key to cache transformed snapshot in localstorage; also removes realtime listening
 */
function bindListener(_ref) {
  var action = _ref.action,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? '_default' : _ref$id,
      query = _ref.query,
      clearingData = _ref.clearingData,
      transform = _ref.transform,
      cachingKey = _ref.cachingKey;

  // get the previous listener if there was one and dedupe if action + id + query are identical
  queryListeners[action] = queryListeners[action] || {};
  if (queryListeners[action][id] && query && queryListeners[action][id].query === query.ot.toString()) {
    console.log('deduped query', query.ot.toString());
    return;
  }

  // deregister old firestore listener to prevent any more updates
  queryListeners[action][id] && queryListeners[action][id].remove && queryListeners[action][id].remove();
  delete queryListeners[action][id];

  // if query data is in cache, then call action with it and skip clearing or realtime updates
  var cachedResult = cachingKey && JSON.parse(localStorage.getItem('_rb-data-cache-' + cachingKey) || null);
  if (cachedResult) {
    store.dispatch(action, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cachedResult, { cached: true }));
    return;
  }

  // clear old data by setting empty/intermediate/loading data, which will propogate clearing for dependent listeners
  clearingData && store.dispatch(action, clearingData);

  // if there's no new query, then just keep it cleared and do not bind a new listener; this allows using ternary operator for conditional clearing
  if (!query) return;

  // make new listener that calls this action
  if (cachingKey) {
    query.get().then(function (snapshot) {
      var result = transform(snapshot);
      localStorage.setItem('_rb-data-cache-' + cachingKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
      store.dispatch(action, result);
    });
  } else {
    var remove = query.onSnapshot(function (snapshot) {
      var result = transform(snapshot);
      store.dispatch(action, result);
    });
    queryListeners[action][id] = {
      remove: remove,
      query: query.ot.toString()
    };
  }
}

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */].Store({
  state: {
    user: __WEBPACK_IMPORTED_MODULE_5__types_js__["a" /* default */].loadingUser,
    currentBusinessId: null,
    businessList: {}, // id indexed businesses that this user has access to; always updates in realtime
    isBusinessListLoading: false,
    partnershipList: {}, // id indexed partnership objects for currently selected business
    selectedMonth: monthStart,
    currentBusinessViews: { byDate: {} }, // date indexed aggregated count of views
    isCurrentBusinessViewsLoading: false,
    currentBusinessPurchases: {}, // date indexed aggregation of count of orders, purchase subtotal, and affiliate commission
    referredPartnerViews: { byPartner: {} }, // partnership indexed then date indexed aggregated count of views referred
    referredPartnerPurchases: { byPartner: {} // partnership indexed then date indexed aggregation of count of orders, purchase subtotal, and affiliate commission
    } },
  getters: {
    user: function user(state) {
      return state.user;
    },
    isLoadingUser: function isLoadingUser(state) {
      return state.user === __WEBPACK_IMPORTED_MODULE_5__types_js__["a" /* default */].loadingUser;
    },
    businessList: function businessList(state) {
      return state.businessList;
    },
    currentBusiness: function currentBusiness(state) {
      return state.currentBusinessId && state.businessList[state.currentBusinessId] || {};
    },
    currentBusinessId: function currentBusinessId(state) {
      return state.currentBusinessId;
    },
    isBusinessListLoading: function isBusinessListLoading(state) {
      return state.isBusinessListLoading;
    },
    isBusinessListEmpty: function isBusinessListEmpty(state) {
      return !state.isBusinessListLoading && __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(state.businessList);
    },
    businessListLength: function businessListLength(state) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(state.businessList);
    },
    currentBusinessViews: function currentBusinessViews(state) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(state.currentBusinessViews.byDate));
    },
    referredPartnerViews: function referredPartnerViews(state) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(state.referredPartnerViews.byPartner));
    },
    referredPurchases: function referredPurchases(state) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(state.referredPartnerPurchases.byPartner), 'totalCount');
    },
    estimatedEarnings: function estimatedEarnings(state) {
      return formatMoney(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(state.referredPartnerPurchases.byPartner), 'totalCommission'));
    }
  },
  mutations: {
    setUser: function setUser(state, _ref2) {
      var user = _ref2.user;

      state.user = user;
    },
    setCurrentBusinessId: function setCurrentBusinessId(state, _ref3) {
      var id = _ref3.id;

      state.currentBusinessId = id;
    },
    setBusinessList: function setBusinessList(state, _ref4) {
      var list = _ref4.list;

      state.businessList = list;
    },
    setIsBusinessListLoading: function setIsBusinessListLoading(state, _ref5) {
      var isBusinessListLoading = _ref5.isBusinessListLoading;

      state.isBusinessListLoading = isBusinessListLoading;
    },
    setPartnershipList: function setPartnershipList(state, _ref6) {
      var list = _ref6.list;

      state.partnershipList = list;
    },
    setCurrentBusinessViews: function setCurrentBusinessViews(state, _ref7) {
      var views = _ref7.views,
          dateKey = _ref7.dateKey;

      if (dateKey) {
        var nextViews = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.currentBusinessViews.byDate);
        nextViews[dateKey] = views;
        state.currentBusinessViews.byDate = nextViews;
      }
    },
    setReferredPartnerViews: function setReferredPartnerViews(state, _ref8) {
      var partnershipId = _ref8.partnershipId,
          partnerViews = _ref8.partnerViews;

      var nextViews = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.referredPartnerViews.byPartner);
      if (partnerViews) {
        nextViews[partnershipId] = partnerViews;
      } else {
        delete nextViews[partnershipId];
      }
      state.referredPartnerViews.byPartner = nextViews;
    },
    setReferredPartnerPurchasees: function setReferredPartnerPurchasees(state, _ref9) {
      var partnershipId = _ref9.partnershipId,
          totalCount = _ref9.totalCount,
          totalCommission = _ref9.totalCommission;

      var nextPurchases = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.referredPartnerPurchases.byPartner);
      if (totalCount) {
        nextPurchases[partnershipId] = { totalCount: totalCount, totalCommission: totalCommission };
      } else {
        delete nextPurchases[partnershipId];
      }
      state.referredPartnerPurchases.byPartner = nextPurchases;
    }
  },
  actions: {
    setUser: function setUser(_ref10, _ref11) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit,
          state = _ref10.state;
      var user = _ref11.user;

      commit('setUser', { user: user });
      if (user == null) {
        localStorage.removeItem('currentBusinessId');
        localStorage.setItem('viewCache', {});
      }

      // TODO get the user data object

      // bind business listener
      bindListener({
        action: 'setBusinessList',
        query: user && user.uid ? businessRef.where('users.' + user.uid, '==', 'full') : null,
        clearingData: { list: {}, loading: true },
        transform: function transform(snapshot) {
          return {
            list: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(snapshot.docs, function (item) {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item.data(), { id: item.id });
            }), 'id'),
            loading: false
          };
        }
      });
    },
    setBusinessList: function setBusinessList(_ref12, _ref13) {
      var commit = _ref12.commit,
          state = _ref12.state,
          dispatch = _ref12.dispatch;
      var list = _ref13.list,
          loading = _ref13.loading;

      commit('setBusinessList', { list: list });
      commit('setIsBusinessListLoading', { isBusinessListLoading: loading });

      // if no business in the list is selected, then dispatch selecting one automatically
      // this handles app startup and business deletions
      var nextId = state.currentBusinessId;
      if (!state.currentBusinessId || !state.businessList[state.currentBusinessId]) {
        // TODO if the business was just selected and they were removed, then we might want to alert the user about what happened
        var storedId = localStorage.getItem('currentBusinessId');
        nextId = storedId && state.businessList[storedId] ? storedId : __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keys(state.businessList)[0];
        dispatch('setCurrentBusinessId', { id: nextId });
      }

      if (!loading && window.location.search) {
        // at this point, we have the businesses and user; if we came from stripe's redirect then try linking the payment
        // const parsedQuery = queryString.parse(window.location.search)
        if (window.location.search.indexOf('scope') && !state.businessList[nextId].paymentMethod) {
          console.log('connecting stripe');
          window.db.collection('business').doc(nextId).set({
            paymentMethod: window.location.search
          }, { merge: true });
        }
      }
    },
    setCurrentBusinessId: function setCurrentBusinessId(_ref14, _ref15) {
      var commit = _ref14.commit,
          state = _ref14.state,
          dispatch = _ref14.dispatch;
      var id = _ref15.id;

      commit('setCurrentBusinessId', { id: id });
      if (id) localStorage.setItem('currentBusinessId', id);

      // whenever a new business is selected, update partnerships listener
      bindListener({
        action: 'setPartnershipList',
        query: id ? partnershipRef.where('affiliate', '==', businessRef.doc(id)) : null,
        clearingData: !__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(state.partnershipList) && { list: {} },
        transform: function transform(snapshot) {
          return {
            list: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(snapshot.docs, function (item) {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item.data(), {
                merchant: item.data().merchant.id,
                affiliate: item.data().affiliate.id,
                id: item.id
              });
            }), 'id')
          };
        }
      });

      dispatch('updateMetrics');
    },
    setPartnershipList: function setPartnershipList(_ref16, _ref17) {
      var commit = _ref16.commit,
          state = _ref16.state;
      var list = _ref17.list;

      var partnershipsToBind = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.defaults({}, list, state.partnershipList);
      commit('setPartnershipList', { list: list });

      // add, update and remove listeners for partnership events
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(partnershipsToBind, function (partnership) {
        // views
        bindListener({
          action: 'setReferredPartnerViews',
          id: partnership.id,
          query: list[partnership.id] // bind null if partnership was removed
          ? businessRef.doc(partnership.merchant).collection('viewEvent').where('affiliateCredit', '==', partnership.id) : null,
          clearingData: { partnershipId: partnership.id, partnerViews: null },
          transform: function transform(snapshot) {
            return { partnershipId: partnership.id, partnerViews: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.invokeMap(snapshot.docs, 'data'), 'uuid')) };
          }
        });
        // purchases
        bindListener({
          action: 'setReferredPartnerPurchasees',
          id: partnership.id,
          query: list[partnership.id] // bind null if partnership was removed
          ? businessRef.doc(partnership.merchant).collection('purchaseEvent').where('affiliateCredit', '==', partnership.id) : null,
          clearingData: { partnershipId: partnership.id, totalCount: null, totalCommission: null },
          transform: function transform(snapshot) {
            return { partnershipId: partnership.id, totalCount: snapshot.size, totalCommission: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.invokeMap(snapshot.docs, 'data'), 'affiliateCommissionCents') };
          }
        });
      });
    },
    updateMetrics: function updateMetrics(_ref18) {
      var commit = _ref18.commit,
          state = _ref18.state;

      // updates all data and listeners for metrics
      // Go through all days before yesterday in current month and set them for view metrics; will fetch if we do not have the metrics stored; re-key cache if data structure changes
      var now = new Date();
      var endDate = state.selectedMonth.getMonth() === now.getMonth() && state.selectedMonth.getFullYear() === now.getFullYear() ? now.getDate() : function () {
        now.setMonth(state.selectedMonth.getMonth() + 1);return now;
      }();
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.range(1, endDate).forEach(function (date) {
        // bind a listener that sets values for that day, include cache key so that the result is stored
        // TODO make getter sum all things
        var startTime = new Date(state.selectedMonth);
        startTime.setHours(0, 0, 0, 0);
        startTime.setDate(date);
        var endTime = new Date(startTime);
        endTime.setDate(startTime.getDate() + 1);
        var dateStr = dateToLocalIsoString(startTime);
        bindListener({
          action: 'setCurrentBusinessViews',
          id: dateStr,
          query: state.currentBusinessId ? businessRef.doc(state.currentBusinessId).collection('viewEvent').where('timestamp', '>=', startTime).where('timestamp', '<', endTime).orderBy('timestamp') : null,
          clearingData: { views: 0, dateKey: dateStr },
          transform: function transform(snapshot) {
            return { views: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.invokeMap(snapshot.docs, 'data'), 'uuid')), dateKey: dateStr };
          },
          cachingKey: 'viewsRev3-' + state.currentBusinessId + dateStr
        });
      });

      var todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      bindListener({
        action: 'setCurrentBusinessViews',
        // TODO also ensure currentMonth is this one, otherwise we need no listener
        query: state.currentBusinessId ? businessRef.doc(state.currentBusinessId).collection('viewEvent').where('timestamp', '>=', todayStart).orderBy('timestamp') : null,
        clearingData: {},
        transform: function transform(snapshot) {
          return { views: snapshot.size, dateKey: dateToLocalIsoString(todayStart) };
        }
      });
    },
    setCurrentBusinessViews: function setCurrentBusinessViews(_ref19, _ref20) {
      var commit = _ref19.commit,
          state = _ref19.state;
      var views = _ref20.views,
          dateKey = _ref20.dateKey;

      commit('setCurrentBusinessViews', { views: views, dateKey: dateKey });
    },
    setReferredPartnerViews: function setReferredPartnerViews(_ref21, _ref22) {
      var commit = _ref21.commit,
          state = _ref21.state;
      var partnershipId = _ref22.partnershipId,
          partnerViews = _ref22.partnerViews;

      commit('setReferredPartnerViews', { partnershipId: partnershipId, partnerViews: partnerViews });
    },
    setReferredPartnerPurchasees: function setReferredPartnerPurchasees(_ref23, _ref24) {
      var commit = _ref23.commit,
          state = _ref23.state;
      var partnershipId = _ref24.partnershipId,
          totalCount = _ref24.totalCount,
          totalCommission = _ref24.totalCommission;

      commit('setReferredPartnerPurchasees', { partnershipId: partnershipId, totalCount: totalCount, totalCommission: totalCommission });
    }
  },
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger___default()()] : []
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "ozKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSettings_vue__ = __webpack_require__("WLhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ea882_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSettings_vue__ = __webpack_require__("vZjm");
function injectStyle (ssrContext) {
  __webpack_require__("T2wN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c9ea882"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ea882_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tHsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnerships_vue__ = __webpack_require__("B06q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be6074d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnerships_vue__ = __webpack_require__("tvcD");
function injectStyle (ssrContext) {
  __webpack_require__("1uMT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be6074d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnerships_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be6074d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnerships_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tvcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Partnerships")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('h2',[_vm._v("Universe Point")]),_vm._v(" "),_c('p',[_vm._v("Commission: 6.5% on cleats")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("http://ultimatefrisbeehq.com")]),_vm._v(" is approved to refer to "),_c('strong',[_vm._v("https://www.universepoint.com")]),_vm._v(". Simply link from your site and referral credit will be given.")]),_vm._v(" "),_c('p',[_vm._v("Payout schedule matches "),_c('a',{attrs:{"href":"https://affiliate-program.amazon.com/help/node/topic/202050210"}},[_vm._v("Amazon's affiliate program")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uIw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingUser)?_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","height":"100vh"}},[_c('Spinner')],1):_c('div',{staticClass:"container"},[_c('div',{staticClass:"colorHalf"},[_c('svg',{staticClass:"logo",attrs:{"width":"556px","height":"375px","viewBox":"0 0 556 375","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Brand-concepts---final-more-intense-red-v5-Copy","transform":"translate(-948.000000, -956.000000)"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(908, 880)"}},[_c('g',{attrs:{"id":"Group-2","transform":"translate(303.957741, 266.840746) rotate(-12.000000) translate(-303.957741, -266.840746) translate(81.457741, 41.840746)"}},[_c('g',{attrs:{"id":"Group-2-Copy-4","transform":"translate(222.578890, 225.247019) rotate(50.000000) translate(-222.578890, -225.247019) translate(53.578890, 77.747019)"}},[_c('g',{attrs:{"id":"Group-Copy-4","transform":"translate(106.231196, 98.616671) scale(-1, 1) rotate(70.000000) translate(-106.231196, -98.616671) translate(32.231196, 16.116671)"}},[_c('g',{attrs:{"id":"Oval-2-Copy-3","transform":"translate(76.261319, 82.332441) rotate(33.000000) translate(-76.261319, -82.332441) "}},[_c('path',{attrs:{"fill":"#ffffff","stroke":"#000000","stroke-width":"15","d":"M77.7637304,163.14924 C65.1293912,163.14924 50.4428118,152.219197 42.0636381,136.575113 C34.8113748,123.034994 31.0602551,103.514005 31.0093699,86.4050311 C30.9796812,76.4228959 31.6417683,50.9206132 32.9968796,9.73611573 C33.072169,7.44792302 34.0673236,5.28685118 35.7570703,3.74210186 C39.2218517,0.574633808 44.5983521,0.815653884 47.7658196,4.28043466 C69.9493414,28.5461999 84.0757619,44.0076924 90.146136,50.6660712 C110.146347,72.6035959 120.703765,93.477381 121.45824,108.566887 C122.770103,134.804137 100.400177,163.14924 77.7637304,163.14924 Z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Group-Copy-3","transform":"translate(0.187780, 65.000000)"}},[_c('g',{attrs:{"id":"Oval-2-Copy-3","transform":"translate(107.167615, 120.405165) scale(1, -1) rotate(-40.000000) translate(-107.167615, -120.405165) "}},[_c('path',{attrs:{"fill":"#ffffff","stroke":"#000000","stroke-width":"15","d":"M131.728863,212.736693 C117.066671,212.736693 99.7499693,199.84926 89.8435813,181.353837 C83.5989087,169.69491 64.3833688,122.811391 31.7360985,39.6809954 C30.9385149,37.6500924 30.9524607,35.3902501 31.7750487,33.3693455 C33.5448614,29.0213331 38.5043385,26.9312893 42.8523481,28.7011009 C103.620342,53.4360447 136.976737,69.5842562 145.565678,79.005162 C169.590013,105.356607 182.227484,130.343005 183.121472,148.222765 C184.669733,179.187979 158.193123,212.736693 131.728863,212.736693 Z"}})])]),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-6","stroke":"#000000","stroke-width":"13","fill":"#ffffff","cx":"206","cy":"165","r":"50"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-5","stroke":"#000000","stroke-width":"13","fill":"#ffffff","cx":"212.102508","cy":"103.37638","r":"40"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Oval-2-Copy-4","stroke":"#000000","stroke-width":"13","fill":"#ffffff","cx":"263.857699","cy":"135.128356","r":"32"}})])])])])]),_vm._v(" "),_c('path',{attrs:{"d":"M29.162,368.966 C30.8020082,369.840671 31.622,370.933993 31.622,372.246 C31.622,372.628669 31.5946669,372.901999 31.54,373.066 C31.0479975,374.815342 29.9546751,375.69 28.26,375.69 C27.9866653,375.69 27.5766694,375.635334 27.03,375.526 C24.8433224,375.143331 23.0666735,374.952 21.7,374.952 C17.7639803,374.952 14.5933454,375.853991 12.188,377.658 C9.78265464,379.462009 8.58,381.894651 8.58,384.956 L8.58,408.9 C8.58,410.212007 8.23833675,411.22333 7.555,411.934 C6.87166325,412.64467 5.8466735,413 4.48,413 C3.16799344,413 2.15667022,412.658337 1.446,411.975 C0.73532978,411.291663 0.38,410.266674 0.38,408.9 L0.38,372.246 C0.38,370.933993 0.73532978,369.92267 1.446,369.212 C2.15667022,368.50133 3.16799344,368.146 4.48,368.146 C7.213347,368.146 8.58,369.512653 8.58,372.246 L8.58,373.804 C10.2200082,371.890657 12.2426546,370.387339 14.648,369.294 C17.0533454,368.200661 19.622653,367.654 22.356,367.654 C25.2533478,367.654 27.5219918,368.091329 29.162,368.966 Z M89.814666,392.459 C89.1039958,393.142337 88.2020048,393.484 87.108666,393.484 L55.948666,393.484 C56.5500024,397.310686 58.2856517,400.399322 61.155666,402.75 C64.0256804,405.100678 67.5379786,406.276 71.692666,406.276 C73.3326742,406.276 75.0409905,405.975336 76.817666,405.374 C78.5943416,404.772664 80.0566603,404.034671 81.204666,403.16 C81.9700032,402.558664 82.8719942,402.258 83.910666,402.258 C84.9493379,402.258 85.7693297,402.531331 86.370666,403.078 C87.354671,403.898004 87.846666,404.827328 87.846666,405.866 C87.846666,406.850005 87.4093371,407.669997 86.534666,408.326 C84.6759901,409.802007 82.3663465,411.004662 79.605666,411.934 C76.8449856,412.863338 74.2073453,413.328 71.692666,413.328 C67.209977,413.328 63.1920171,412.357676 59.638666,410.417 C56.0853149,408.476324 53.3110093,405.784017 51.315666,402.34 C49.3203227,398.895983 48.322666,394.987355 48.322666,390.614 C48.322666,386.240645 49.2656566,382.318351 51.151666,378.847 C53.0376755,375.375649 55.6616492,372.669676 59.023666,370.729 C62.3856828,368.788324 66.1986447,367.818 70.462666,367.818 C74.6720204,367.818 78.3073174,368.747324 81.368666,370.606 C84.4300147,372.464676 86.7806578,375.061317 88.420666,378.396 C90.0606742,381.730683 90.880666,385.557312 90.880666,389.876 C90.880666,390.914672 90.5253363,391.775663 89.814666,392.459 Z M60.745666,378.15 C58.2583203,380.336678 56.6866693,383.261315 56.030666,386.924 L83.336666,386.924 C82.8446636,383.261315 81.4780106,380.336678 79.236666,378.15 C76.9953215,375.963322 74.0706841,374.87 70.462666,374.87 C66.4719794,374.87 63.2330118,375.963322 60.745666,378.15 Z M127.179332,359.536 C125.320656,361.558677 124.391332,364.237317 124.391332,367.572 L124.391332,369.786 L132.755332,369.786 C133.903338,369.786 134.832662,370.113997 135.543332,370.77 C136.254002,371.426003 136.609332,372.300661 136.609332,373.394 C136.609332,374.378005 136.254002,375.197997 135.543332,375.854 C134.832662,376.510003 133.903338,376.838 132.755332,376.838 L124.391332,376.838 L124.391332,408.818 C124.391332,410.07534 124.008669,411.086663 123.243332,411.852 C122.477995,412.617337 121.412006,413 120.045332,413 C118.951993,413 118.009003,412.617337 117.216332,411.852 C116.423661,411.086663 116.027332,410.07534 116.027332,408.818 L116.027332,376.838 L112.501332,376.838 C111.353326,376.838 110.424002,376.510003 109.713332,375.854 C109.002662,375.197997 108.647332,374.378005 108.647332,373.394 C108.647332,372.300661 109.002662,371.426003 109.713332,370.77 C110.424002,370.113997 111.353326,369.786 112.501332,369.786 L116.027332,369.786 L116.027332,368.392 C116.027332,364.510647 116.806324,361.107681 118.364332,358.183 C119.92234,355.258319 122.108985,352.989675 124.924332,351.377 C127.739679,349.764325 130.951314,348.958 134.559332,348.958 C135.762005,348.958 136.759661,349.31333 137.552332,350.024 C138.345003,350.73467 138.741332,351.636661 138.741332,352.73 C138.741332,353.823339 138.345003,354.72533 137.552332,355.436 C136.759661,356.14667 135.762005,356.502 134.559332,356.502 C131.497983,356.502 129.038008,357.513323 127.179332,359.536 Z M196.523998,392.459 C195.813328,393.142337 194.911337,393.484 193.817998,393.484 L162.657998,393.484 C163.259334,397.310686 164.994984,400.399322 167.864998,402.75 C170.735012,405.100678 174.247311,406.276 178.401998,406.276 C180.042006,406.276 181.750323,405.975336 183.526998,405.374 C185.303674,404.772664 186.765992,404.034671 187.913998,403.16 C188.679335,402.558664 189.581326,402.258 190.619998,402.258 C191.65867,402.258 192.478662,402.531331 193.079998,403.078 C194.064003,403.898004 194.555998,404.827328 194.555998,405.866 C194.555998,406.850005 194.118669,407.669997 193.243998,408.326 C191.385322,409.802007 189.075679,411.004662 186.314998,411.934 C183.554318,412.863338 180.916677,413.328 178.401998,413.328 C173.919309,413.328 169.901349,412.357676 166.347998,410.417 C162.794647,408.476324 160.020341,405.784017 158.024998,402.34 C156.029655,398.895983 155.031998,394.987355 155.031998,390.614 C155.031998,386.240645 155.974989,382.318351 157.860998,378.847 C159.747008,375.375649 162.370981,372.669676 165.732998,370.729 C169.095015,368.788324 172.907977,367.818 177.171998,367.818 C181.381352,367.818 185.016649,368.747324 188.077998,370.606 C191.139347,372.464676 193.48999,375.061317 195.129998,378.396 C196.770006,381.730683 197.589998,385.557312 197.589998,389.876 C197.589998,390.914672 197.234668,391.775663 196.523998,392.459 Z M167.454998,378.15 C164.967652,380.336678 163.396001,383.261315 162.739998,386.924 L190.045998,386.924 C189.553996,383.261315 188.187343,380.336678 185.945998,378.15 C183.704654,375.963322 180.780016,374.87 177.171998,374.87 C173.181311,374.87 169.942344,375.963322 167.454998,378.15 Z M250.698664,368.966 C252.338672,369.840671 253.158664,370.933993 253.158664,372.246 C253.158664,372.628669 253.131331,372.901999 253.076664,373.066 C252.584662,374.815342 251.491339,375.69 249.796664,375.69 C249.523329,375.69 249.113334,375.635334 248.566664,375.526 C246.379987,375.143331 244.603338,374.952 243.236664,374.952 C239.300644,374.952 236.130009,375.853991 233.724664,377.658 C231.319319,379.462009 230.116664,381.894651 230.116664,384.956 L230.116664,408.9 C230.116664,410.212007 229.775001,411.22333 229.091664,411.934 C228.408327,412.64467 227.383338,413 226.016664,413 C224.704658,413 223.693334,412.658337 222.982664,411.975 C222.271994,411.291663 221.916664,410.266674 221.916664,408.9 L221.916664,372.246 C221.916664,370.933993 222.271994,369.92267 222.982664,369.212 C223.693334,368.50133 224.704658,368.146 226.016664,368.146 C228.750011,368.146 230.116664,369.512653 230.116664,372.246 L230.116664,373.804 C231.756672,371.890657 233.779319,370.387339 236.184664,369.294 C238.590009,368.200661 241.159317,367.654 243.892664,367.654 C246.790012,367.654 249.058656,368.091329 250.698664,368.966 Z M310.32633,370.77 C313.524346,372.73801 316.038988,375.457649 317.87033,378.929 C319.701673,382.400351 320.61733,386.267979 320.61733,390.532 C320.61733,394.796021 319.63334,398.663649 317.66533,402.135 C315.69732,405.606351 312.977681,408.339657 309.50633,410.335 C306.034979,412.330343 302.194685,413.328 297.98533,413.328 C293.775976,413.328 289.963014,412.330343 286.54633,410.335 C283.129646,408.339657 280.423673,405.606351 278.42833,402.135 C276.432987,398.663649 275.43533,394.796021 275.43533,390.532 L275.43533,353.14 C275.43533,351.88266 275.83166,350.871337 276.62433,350.106 C277.417001,349.340663 278.414657,348.958 279.61733,348.958 C280.87467,348.958 281.885993,349.340663 282.65133,350.106 C283.416667,350.871337 283.79933,351.88266 283.79933,353.14 L283.79933,375.28 C285.712673,372.929322 288.035983,371.098007 290.76933,369.786 C293.502677,368.473993 296.454648,367.818 299.62533,367.818 C303.56135,367.818 307.128314,368.80199 310.32633,370.77 Z M305.40633,403.939 C307.620341,402.59966 309.369657,400.754678 310.65433,398.404 C311.939003,396.053322 312.58133,393.429348 312.58133,390.532 C312.58133,387.634652 311.939003,385.024345 310.65433,382.701 C309.369657,380.377655 307.620341,378.54634 305.40633,377.207 C303.192319,375.86766 300.718677,375.198 297.98533,375.198 C295.251983,375.198 292.778341,375.86766 290.56433,377.207 C288.350319,378.54634 286.61467,380.377655 285.35733,382.701 C284.099991,385.024345 283.47133,387.634652 283.47133,390.532 C283.47133,393.429348 284.099991,396.053322 285.35733,398.404 C286.61467,400.754678 288.350319,402.59966 290.56433,403.939 C292.778341,405.27834 295.251983,405.948 297.98533,405.948 C300.718677,405.948 303.192319,405.27834 305.40633,403.939 Z M385.943996,392.459 C385.233326,393.142337 384.331335,393.484 383.237996,393.484 L352.077996,393.484 C352.679333,397.310686 354.414982,400.399322 357.284996,402.75 C360.155011,405.100678 363.667309,406.276 367.821996,406.276 C369.462004,406.276 371.170321,405.975336 372.946996,405.374 C374.723672,404.772664 376.18599,404.034671 377.333996,403.16 C378.099333,402.558664 379.001324,402.258 380.039996,402.258 C381.078668,402.258 381.89866,402.531331 382.499996,403.078 C383.484001,403.898004 383.975996,404.827328 383.975996,405.866 C383.975996,406.850005 383.538667,407.669997 382.663996,408.326 C380.80532,409.802007 378.495677,411.004662 375.734996,411.934 C372.974316,412.863338 370.336675,413.328 367.821996,413.328 C363.339307,413.328 359.321347,412.357676 355.767996,410.417 C352.214645,408.476324 349.440339,405.784017 347.444996,402.34 C345.449653,398.895983 344.451996,394.987355 344.451996,390.614 C344.451996,386.240645 345.394987,382.318351 347.280996,378.847 C349.167006,375.375649 351.790979,372.669676 355.152996,370.729 C358.515013,368.788324 362.327975,367.818 366.591996,367.818 C370.801351,367.818 374.436648,368.747324 377.497996,370.606 C380.559345,372.464676 382.909988,375.061317 384.549996,378.396 C386.190004,381.730683 387.009996,385.557312 387.009996,389.876 C387.009996,390.914672 386.654666,391.775663 385.943996,392.459 Z M356.874996,378.15 C354.38765,380.336678 352.815999,383.261315 352.159996,386.924 L379.465996,386.924 C378.973994,383.261315 377.607341,380.336678 375.365996,378.15 C373.124652,375.963322 370.200014,374.87 366.591996,374.87 C362.60131,374.87 359.362342,375.963322 356.874996,378.15 Z M440.118662,368.966 C441.75867,369.840671 442.578662,370.933993 442.578662,372.246 C442.578662,372.628669 442.551329,372.901999 442.496662,373.066 C442.00466,374.815342 440.911337,375.69 439.216662,375.69 C438.943328,375.69 438.533332,375.635334 437.986662,375.526 C435.799985,375.143331 434.023336,374.952 432.656662,374.952 C428.720643,374.952 425.550008,375.853991 423.144662,377.658 C420.739317,379.462009 419.536662,381.894651 419.536662,384.956 L419.536662,408.9 C419.536662,410.212007 419.194999,411.22333 418.511662,411.934 C417.828325,412.64467 416.803336,413 415.436662,413 C414.124656,413 413.113332,412.658337 412.402662,411.975 C411.691992,411.291663 411.336662,410.266674 411.336662,408.9 L411.336662,372.246 C411.336662,370.933993 411.691992,369.92267 412.402662,369.212 C413.113332,368.50133 414.124656,368.146 415.436662,368.146 C418.170009,368.146 419.536662,369.512653 419.536662,372.246 L419.536662,373.804 C421.17667,371.890657 423.199317,370.387339 425.604662,369.294 C428.010008,368.200661 430.579315,367.654 433.312662,367.654 C436.21001,367.654 438.478654,368.091329 440.118662,368.966 Z M493.637328,368.966 C495.277336,369.840671 496.097328,370.933993 496.097328,372.246 C496.097328,372.628669 496.069995,372.901999 496.015328,373.066 C495.523326,374.815342 494.430003,375.69 492.735328,375.69 C492.461994,375.69 492.051998,375.635334 491.505328,375.526 C489.318651,375.143331 487.542002,374.952 486.175328,374.952 C482.239309,374.952 479.068674,375.853991 476.663328,377.658 C474.257983,379.462009 473.055328,381.894651 473.055328,384.956 L473.055328,408.9 C473.055328,410.212007 472.713665,411.22333 472.030328,411.934 C471.346991,412.64467 470.322002,413 468.955328,413 C467.643322,413 466.631998,412.658337 465.921328,411.975 C465.210658,411.291663 464.855328,410.266674 464.855328,408.9 L464.855328,372.246 C464.855328,370.933993 465.210658,369.92267 465.921328,369.212 C466.631998,368.50133 467.643322,368.146 468.955328,368.146 C471.688675,368.146 473.055328,369.512653 473.055328,372.246 L473.055328,373.804 C474.695336,371.890657 476.717983,370.387339 479.123328,369.294 C481.528674,368.200661 484.097981,367.654 486.831328,367.654 C489.728676,367.654 491.99732,368.091329 493.637328,368.966 Z M555.191994,371.754 C555.191994,372.300669 555.027996,372.956663 554.699994,373.722 L529.607994,430.138 C528.951991,431.832675 527.886002,432.68 526.409994,432.68 C525.863325,432.68 525.207331,432.516002 524.441994,432.188 C522.801986,431.47733 521.981994,430.41134 521.981994,428.99 C521.981994,428.333997 522.145993,427.678003 522.473994,427.022 L530.673994,408.572 L512.223994,373.558 C511.95066,373.065998 511.813994,372.492003 511.813994,371.836 C511.813994,371.12533 512.032659,370.469336 512.469994,369.868 C512.90733,369.266664 513.481324,368.802002 514.191994,368.474 C514.683997,368.255332 515.230658,368.146 515.831994,368.146 C517.362669,368.146 518.510657,368.911326 519.275994,370.442 L534.281994,400.29 L547.483994,370.524 C548.194664,368.938659 549.260654,368.146 550.681994,368.146 C551.392664,368.146 552.048658,368.282665 552.649994,368.556 C554.344669,369.212003 555.191994,370.277993 555.191994,371.754 Z","id":"referberry","fill":"#ffffff"}})])]),_vm._v(" "),_c('div',{staticClass:"buttonHalf"},[_c('div',{staticClass:"buttonContainer"},[_c('button',{staticStyle:{"position":"relative"},attrs:{"type":"button"},on:{"click":_vm.loginGoogle}},[_c('span',{staticClass:"inputIcon googleIcon",attrs:{"data-icon":"ei-sc-google-plus","data-size":"s"}}),_vm._v("\n              Login with Google\n            ")]),_vm._v(" "),_c('form',{on:{"submit":_vm.loginEmail}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"inputIcon rightMiddle",attrs:{"data-icon":"ei-envelope","data-size":"s"}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"inputIcon rightMiddle",attrs:{"data-icon":"ei-lock","data-size":"s"}})]),_vm._v(" "),_c('button',{staticClass:"btnLoginWithEmail",attrs:{"type":"submit"}},[_vm._v("Login / Sign up")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider"},[_c('span',[_vm._v("or")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vZjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Settings")]),_vm._v(" "),(_vm.businessListLength > 1)?_c('div',[_c('h2',[_vm._v("Current Business")]),_vm._v("\nYou're currently managing\n  "),_c('select',{staticClass:"business-list",domProps:{"value":_vm.currentBusinessId},on:{"change":_vm.setCurrentBusinessId}},[_vm._l((_vm.businessList),function(business){return [_c('option',{domProps:{"value":business.id}},[_vm._v(_vm._s(business.displayName))])]})],2)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("Log out")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logo__ = __webpack_require__("2AE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner__ = __webpack_require__("+jyM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      visits: 0,
      purchases: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'isLoadingUser', 'isBusinessListLoading', 'currentBusiness', 'isBusinessListEmpty'])),

  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_2__components_Logo__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner__["a" /* default */]
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2369d990_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("uIw4");
function injectStyle (ssrContext) {
  __webpack_require__("7HVi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2369d990"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2369d990_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0094afb86e3f8c085479.js